import { jwtDecode } from "jwt-decode";
import axios from "../../axios/axios";

import { Action, Dispatch } from "redux";
import { EditUser, LoginUser, User } from "../../ts/Auth";
import { setAuthToken } from "../../utils";
import { TLoginUserBody } from "../../types/server-api/user";
import { userModel } from "../../api/models/userModel";
import Cookies from "js-cookie";

export const EDIT_USER =
  (id: string, user: EditUser) =>
  (dispatch: Dispatch<Action<"SET_USER" | "SET_ERRORS">>) => {
    axios
      .post("/users/edit", { id, user })
      .then((res) => {
        const { token } = res.data;
        localStorage.setItem("jwtToken", token);
        setAuthToken(token);
        const decoded = jwtDecode(token);
        dispatch({
          type: "SET_ERRORS",
          payload: {},
        });
        dispatch({
          type: "SET_USER",
          payload: {
            user: decoded,
            logged: true,
          },
        });
      })
      .catch(({ response }) => {
        if (response)
          dispatch({
            type: "SET_ERRORS",
            payload: response.data.errors,
          });
      });
  };

type TDecodedUser = {
  exp: number;
  iat: number;
  user: User | null;
};

const SET_USER_FROM_TOKEN = (token: string) => {
  Cookies.set("_token", token, {
    expires: 28,
    // sameSite: "strict",
    // secure: true,
  });
  const decoded: TDecodedUser = jwtDecode(token);

  return decoded;
};

export const LOGIN_USER = async (data: TLoginUserBody) => {
  const { token } = await userModel.loginUser(data);

  const decoded = SET_USER_FROM_TOKEN(token);

  return {
    type: "SET_USER",
    payload: decoded,
  };
};

export const LOGOUT_USER = () => {
  Cookies.remove("_token");

  return {
    type: "SET_USER",
    payload: null,
  };
};
